<template>
  <div class="swiper-box" v-if="(banner || '') != ''">
    <el-carousel>
      <el-carousel-item v-for="(item, index) in banner" :key="index">
        <a :href="item.remark"
          class="bg-img"
          :style="{ backgroundImage: 'url(' + item.banner_pic + ')' }"
        ></a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { fetch } from "../utils/request";

export default {
  name: "Banner",
  props: ["position_code"],
  data() {
    return {
      banner: [],
      exi_id: "",
      query_data: {
        exi_id: null
      }
    };
  },
  computed: {
    exi_oid() {
      return this.$store.state.exiOid;
    }
  },
  watch: {
    exi_oid: {
      immediate: true,
      handler() {
        this.getBelowList();
      }
    }
  },
  mounted() {},
  methods: {
    getBelowList() {
      this.exi_id = this.$store.state.exiOid;
      this.query_data.exi_id = this.$store.state.exiOid;
      this.query_data.status = 0;
      this.query_data.position_code = this.position_code;
      if (this.query_data.exi_id) {
        this.getBanner();
      }
    },
    getBanner() {
      fetch("post", "/banner/retrieve", this.query_data).then(res => {
        if (res.status == 0) {
          console.log("banner---", res);
          this.banner = res.data.datas;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/reset_element.scss";

/deep/ .el-carousel__container{
  height: 580px;
}
.swiper-box {
 height: 580px;
  .el-carousel__item {
  
    .bg-img {
      width: 100%;
      height: 580px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-size: 100% 100%;
      background-repeat: no-repeat;
   
      background-position: center center;
    }
  }
}
/deep/ .el-carousel__indicators--horizontal {
  padding: 0;
  .el-carousel__indicator--horizontal button {
    width: 24px;
    height: 24px;
    border: 4px solid #fff;
    border-radius: 50%;
    background: rgba(255, 0, 0, 0);
    margin: 0 32px;
    opacity: 1;
  }

  .el-carousel__indicator--horizontal.is-active button {
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue